import React from "react";
import { displayAccountLabel } from "@common/helpers/accounting";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import {
    TransactionForLedgerAccount,
    useTransactionLedgerAccount,
} from "@hooks/useTransactionLedgerAccount";

interface Props {
    transaction: TransactionForLedgerAccount;
}

export const TransactionCashLedgerColumnContent: React.FC<Props> = ({
    transaction,
}) => {
    const showAccountNumbers = useShowAccountNumbers();
    const { account } = useTransactionLedgerAccount(transaction, {
        includeCurrentAccount: true,
        currentAccountId: transaction.accountId ?? undefined,
        basis: AccountingLedgerBasis.cash,
    });

    return (
        <BreakableText
            text={
                account
                    ? displayAccountLabel(account, showAccountNumbers)
                    : undefined
            }
        />
    );
};
